export const spacer = {
  bg: 'transparent',
};
